import React from "react";

export default function AddPatientIcon() {
  return (
    <svg
      width="29"
      height="27"
      viewBox="0 0 29 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 16H11C10.7348 16 10.4804 16.1054 10.2929 16.2929C10.1054 16.4804 10 16.7348 10 17V21H2V11C2 10.7348 1.89464 10.4804 1.70711 10.2929C1.51957 10.1054 1.26522 10 1 10C0.734784 10 0.48043 10.1054 0.292893 10.2929C0.105357 10.4804 0 10.7348 0 11V26C0 26.2652 0.105357 26.5196 0.292893 26.7071C0.48043 26.8946 0.734784 27 1 27C1.26522 27 1.51957 26.8946 1.70711 26.7071C1.89464 26.5196 2 26.2652 2 26V23H26V26C26 26.2652 26.1054 26.5196 26.2929 26.7071C26.4804 26.8946 26.7348 27 27 27C27.2652 27 27.5196 26.8946 27.7071 26.7071C27.8946 26.5196 28 26.2652 28 26V20C27.9989 18.9395 27.5771 17.9227 26.8272 17.1728C26.0773 16.4229 25.0605 16.0011 24 16Z"
        fill="#4C8395"
      />
      <path
        d="M6 21C7.65685 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21Z"
        fill="#4C8395"
      />
      <path
        d="M22 0C21.5359 0 21.0908 0.184375 20.7626 0.512563C20.4344 0.840752 20.25 1.28587 20.25 1.75V5.25H16.75C16.2859 5.25 15.8408 5.43437 15.5126 5.76256C15.1844 6.09075 15 6.53587 15 7C15 7.46413 15.1844 7.90925 15.5126 8.23744C15.8408 8.56563 16.2859 8.75 16.75 8.75H20.25V12.25C20.25 12.7141 20.4344 13.1592 20.7626 13.4874C21.0908 13.8156 21.5359 14 22 14C22.4641 14 22.9092 13.8156 23.2374 13.4874C23.5656 13.1592 23.75 12.7141 23.75 12.25V8.75H27.25C27.7141 8.75 28.1592 8.56563 28.4874 8.23744C28.8156 7.90925 29 7.46413 29 7C29 6.53587 28.8156 6.09075 28.4874 5.76256C28.1592 5.43437 27.7141 5.25 27.25 5.25H23.75V1.75C23.75 1.28587 23.5656 0.840752 23.2374 0.512563C22.9092 0.184375 22.4641 0 22 0Z"
        fill="#4C8395"
      />
    </svg>
  );
}
